import { ApiResponse } from "../Models";

export const confirmEmailResponseMockup: ApiResponse<string> = {
    statusCode: 200,
    error: null,
    data: "Great Success",
};
